//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum CryptType {
	Plain = 0,
	Reversible = 1,
	Irreversible = 2
}
